const notifications = {
    addToDesktop: {
        description:
            'Добавьте нашу иконку на рабочий стол: нажмите «Поделиться» и выберите «На экран «Домой»',
        button: 'Понятно',
    },
};

export default notifications;
